import { css } from "lit";

const RecordingButtonStyles = css`
  :host {
    display: inline-flex;
  }
`;

export default RecordingButtonStyles;
